module.exports = __webpack_public_path__ + "assets/img/官网首页_08.a0fb285b.jpg";